import React, { useState, useEffect, useRef } from 'react'

import { useDispatch, useSelector, shallowEqual } from 'react-redux'


import { Table, Tooltip,Tag,Form, Input, Button, Space,Modal,Descriptions,Divider,
  Statistic, Col,Popconfirm,Collapse,Select,DatePicker, Upload,
  TimePicker,Checkbox, message} from 'antd';
import {   
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined, 
    DeploymentUnitOutlined,
    SearchOutlined,
    EditOutlined,
    PlusOutlined,
    SaveOutlined
} from '@ant-design/icons';

import './styles.scss'

import moment from 'moment'
import {getData,editItem,addItem,deleteItem,updateItem} from '../../../Redux/actions/crudActions'
import {setPrice,UploadProductPicture} from '../../../Redux/actions/productActions'

import {errorParser} from '../../../utils/helpers'

import ImageChecker from '../../Generic/ImageChecker'

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

const Index = ({currentItem,somethingChanged}) => { 

  const dispatch = useDispatch()    
  const siteEditorRef = useRef(null);
  const { user } = useSelector(state => ({
    user: state.auth.user,
  }), shallowEqual)


  const [currentValue, setCurrentvalue] = useState(null)
  const [refreshImage, setRefreshImage] = useState(moment().format('SSS'))


  useEffect(() => {
    // console.log('changeval',  `${process.env.REACT_APP_AWS_S3}${currentItem.id}.png`)


  }, [])



  const preview = async (val) =>{
    var src =  await getBase64(val);
    setCurrentvalue(src)

  }
  
  const uploadButton = () =>{
    return (
      <div className={"picuploadbox"}>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    )  
  }

  
  const onChange = (file)=>{
  
    if(user.role =='admin' || user.role =='warehouse' || user.role == 'manager'){
      console.log(file,currentItem,currentItem.id)
      dispatch(UploadProductPicture(file,currentItem.id))
      .then(data => {console.log(data); setRefreshImage(moment().format('SSS'))})
      .catch(err => {console.log(err); setRefreshImage(moment().format('SSS'))})
      somethingChanged(true)
    }

  }

  return ( 
    <div className="productpicture_container">
      <Upload
        name="avatar"
        listType="picture"

        showUploadList={false}

        // beforeU(pload={beforeUpload}
        onChange={(e)=>{onChange(e.file.originFileObj)}}
      >
      <ImageChecker                 
            url={`${process.env.REACT_APP_AWS_S3}${currentItem.id}.png`}
            success={      
              <img src={`${process.env.REACT_APP_AWS_S3}${currentItem.id}.png?${refreshImage}`} alt="image"   className={"pictureinput"}/>                           
            }
            fail= { uploadButton()}
        />
      </Upload>

    </div>

    )
    
}
  
export default Index
  